<template>
  <CContainer class="d-flex content-center min-vh-100">
    <CRow>
      <CCol>
        <CCardGroup>
          <CCard class="p-4">
            <CCardBody>
              <img
                src="/img/brand/backend-logo-login.png" 
                class="logo-backend"
                />
              <CForm @submit.prevent="login" method="POST">
                <h1>Login</h1>
                <p class="text-muted">Sign In to your account</p>
                <CInput
                  v-model="username"
                  prependHtml="<i class='cui-user'></i>"
                  placeholder="Username"
                  autocomplete="username email"
                >
                  <template #prepend-content><CIcon name="cil-user"/></template>
                </CInput>
                <CInput
                  v-model="password"
                  prependHtml="<i class='cui-lock-locked'></i>"
                  placeholder="Password"
                  type="password"
                  autocomplete="curent-password"
                >
                  <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                </CInput>
                <CRow>
                  <CCol col="6">
                    <CButton type="submit" color="primary" class="px-4">Login</CButton>
                  </CCol>
                </CRow>
              </CForm>
            </CCardBody>
          </CCard>
        </CCardGroup>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
import axios from "axios";
import { mapActions } from "vuex";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      showMessage: false,
      message: '',
    }
  },
  methods: {
    ...mapActions(['setPermissions', 'setStore']),
    login() {
      axios.post('/api/login', {
        username: this.username,
        password: this.password,
      }).then(response => {
        this.username = '';
        this.password = '';
        localStorage.setItem("api_token", response.data.access_token);
        localStorage.setItem('permissions', JSON.stringify(response.data.permissions));
        this.setStore(['token', response.data.access_token]);
        this.setStore(['currentUser', JSON.stringify(response.data.currentUser)]);
        this.setPermissions(response.data.permissions);
        this.$router.push({ path: 'dashboard' });
      })
      .catch(error => {
        const serverMsg = error.response?.data?.error;
        this.showAlert(serverMsg || 'Incorrect username or password');
        console.log(error);
      });
    },
    showAlert(msg) {
      let title = 'Login';
      let body = msg;
      let status = 'danger';

      this.$swal(
        title,
        body,
        status
      );
    },
  }
}

</script>

<style lang="scss" scoped>
.logo-backend {
  width: 140px;
}
</style>
